<template>
    <div class="main">
       <navComponent :activeName="activeName"></navComponent>
        <newProductDetilsBanner :routerId="routerId"></newProductDetilsBanner>
        <div class="Provincial-Introduction">
            <div class="Provincial-Introduction-center">
                <div class="province-title">{{productInfo.title}}</div>
                <div class="province-desc">{{productInfo.desc}}</div>
            </div>
        </div>
        <Itinerary :itinerary="itinerary"></Itinerary>
        <ConfigurationLevel :viewportWidth="String(viewportWidth)"></ConfigurationLevel>
         <fromComponent :viewportWidth="String(viewportWidth)"></fromComponent>
         <footerComponent></footerComponent>
    </div>
</template>
<script>
    import navComponent from '/components/pc/headerComponent/navComponent.vue'
    import newProductDetilsBanner from '/components/pc/headerComponent/newProductDetilsBanner/newProductDetilsBanner.vue'
    import productDetilsInfo from '/js/newProductDetils/itinerary.js'
    import Itinerary from '/components/pc/newProductDetils/itineraryComponent.vue'
    import ConfigurationLevel from '/components/pc/newProductDetils/configurationLevel.vue'
    import fromComponent from '/components/pc/fromComponent/fromComponent.vue'
    import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
    export default{
        components:{
            newProductDetilsBanner,
            Itinerary,
            ConfigurationLevel,
            fromComponent,
            footerComponent,
            navComponent
        },
        data(){
            return {
                activeName: 'fifth',
                productInfo:{},
                itinerary:[],
                routerId:0,
                viewportWidth:0,
            }
        },
        created(){
            this.routerId = this.$route.query.id
            this.productInfo = productDetilsInfo.productDetilsInfo[this.routerId-1]
            this.itinerary = this.productInfo.Itinerary
        },
         mounted(){
            this.viewportWidth = window.innerWidth;
            window.addEventListener('resize', this.handleResize);
        },
         beforeDestroy() {
            // 组件销毁时移除事件监听器
            window.removeEventListener('resize', this.handleResize);
        },
        methods:{
            handleResize() {
                this.viewportWidth = window.innerWidth;
            },
             tabClickEvent(name) {
                this.activeName = name
                if(name == 'first'){
                this.$router.push('/')
                }else if(name == 'third'){
                this.$router.push('/aboutUs')
                }else if(name == 'fourth'){
                this.$router.push('/moveNow')
                }
            },
        }
    }
</script>
<style scoped lang="scss">
@import '/style/phone/newProductDetils/newProductDetils.scss';
    .main {
        .Provincial-Introduction {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 3.125rem 0 2.5rem 0;

            .Provincial-Introduction-center {
                width: 75rem;

                .province-title {
                    color: #191919;
                    font-size: 2rem;
                    font-weight:700;
                    line-height: 1.2;
                    margin-bottom: 0.875rem;
                    font-family: Butler;
                }

                .province-desc {
                    color: #09080D;
                    font-size: 1.25rem;
                    font-weight: 400;
                    font-family: Inter;
                    line-height: 1.5;
                }
            }
        }
    }
</style>
